import { css } from 'styled-components';

const cssVariables = css`
  :root {
    // colors
    --primaryAlt: #d65a1b;
    --roundelColor: #0d9828;
    --contentText: #1a1716;
    --contentTextAlt: #5c534e;
    --buttonToggleColor: #ee6f2e;
    --homepageBannerColor: #f18d02;
    --homeEmergencyItemMobileColor: #444444;
    --homeEmergencyIconBackgroundColor: #fef5f0;
    --whyChooseUsIconBackgroundColor: #fef5f0;
    --paragraphTextColor: #444444;
    --coverPlanLinkColor: #4472ca;
    --discountInputColor: #303030;
    --cardShadow: 0 2px 30px 0 rgba(0, 0, 0, 0.07);
    --cardBGColor: #fff;
    --cardBorderColor: #d8d8d8;
    --planBorderColor: #d7d7d7;
    --tableColor: #303030;
    --tableListColor: #444444;
    --yourQuoteHeaderTopDescription: #505050;
    --yourQuoteBetterPlanBorderColor: #e49335;
    --progressBarColor: #e49335;
    --coverJourneyHeaderDiscountValueColor: #ee6f2e;
    --coverJourneyHeaderDiscountColor: #303030;
    --coverJourneyAboutYouTextColor: #303030;
    --coverJourneySubtitleTextColor: #444444;
    --tooltipInfoBGColor: #fff;
    --tooltipWithButtonsBorderColor: #e49335;
    --infoPopupTextColor: #4472ca;
    --errorTextColor: #f00;
    --linkColor: #4472ca;
    --homePageBackgroundColor: #f9f8f6;
    --staticTextsPageBackgroundColor: #f9f8f6;
    --staticTextsPageBorderColor: #d7d7d7;
    --staticTextsTableBackground: #ffffff;
    --cookieBannerBGColor: #58504c;
    --cookieBannerTextColor: #fff;
    --stepperIconsColor: #36c6c8;
    --errorMessageColor: #f00;
    --errorBorderColor: #ff9b9b;
    --errorBackgroundColor: #fff2f2;
    --modalDescription: #505050;
    --adviceDescription: #303030;
    --adviceListNumbers: #000;
    --homePageHeaderBackgroundColor: #f2efe0;
    --formBorder: #d2d2dc;
    --checkboxRectangleActiveBackground: rgba(68, 114, 202, 0.1);
    --checkboxRectangleBackground: #fff;
    --numericListColor: #505050;
    --selectInputColor: #333f48;
    --discountSuccessTextColor: #000;
    --budgetTextColor: #fff;
    --coverPlanLinksColor: #303030;
    --dashSighColor: #dedede;
    --fileUploadNameColor: #6f6f6f;
    --removeDiscountBorderColor: #dedede;
    --removeDiscountColor: #6e6e6e;
    --removeDiscountHoverColor: #4472ca;
    --errorPageTitleGradient: linear-gradient(
        100deg,
        rgba(255, 255, 255, 0.5) 25%,
        rgba(0, 0, 0, 0.5) 101%
      ),
      linear-gradient(to bottom, #f08e00, #f08e00);
    --comparePlansButtonColor: #303030;
    --planDetailsTabTitleColor: #303030;
    --footnotesItemContentColor: #444444;
    --errorBase: #c7153e;
    --funnelBase: #ffd233;
    --funnelAlt: #bf9500;
    --headerSalesFunnelBg: #ee6f2e;
    --salesFunnelMainColor: #ee6f2e;
    --funnelProgressBar: #f9f7f6;
    --funnelRadioBorder: #8c7f79;
    --funnelRadioBg: #fa9b3f;
    --funnelErrorMuted: #faf0f2;
    --contentBorderAlt: #c8c8c8;
    --quoteCardShadow: #ffbd70;
    --contentBorder: #8c7f79;
    --quoteCardShadowOpac: rgba(255, 189, 112, 0.2);
    --promoOrange: #f18f02;
  }
`;

export default cssVariables;
